
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Communiquer sur Internet : Google My Business, c’est quoi ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez ce qu'est Google My Business et comment l'exploiter pour renforcer votre présence en ligne et attirer plus de clients avec un outil gratuit et puissant.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Communiquer sur Internet : Google My Business, c’est quoi ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Une fiche Google My Business constitue un outil gratuit et puissant. Comment l’utiliser efficacement pour renforcer votre présence en ligne ?",
        },
      ],
    };
  },
};
